import React from 'react';

import { InboxOutlined } from '@ant-design/icons';
import { Card, Statistic } from 'antd';
import { useTranslation } from 'react-i18next';

const TodayInboundsWidget = () => {
  const { t } = useTranslation();

  return (
    <Card className="dashboard-widget dashboard-widget--today-inbounds">
      <Statistic
        title={t('operator.dashboard.widgets.today_inbounds.title')}
        value={0}
        prefix={<InboxOutlined />}
        valueStyle={{ color: '#52c41a' }}
      />
    </Card>
  );
};

export default TodayInboundsWidget;
